import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles/index";
import { ThumbUp } from "material-ui-icons";
import { IconButton, CircularProgress, Button, Typography } from "material-ui";
import classNames from "classnames";
import blue from "material-ui/colors/blue";
import { grey } from "material-ui/colors/index";

const styleSheet = theme => ({
    root: {
        display: "flex",
        alignItems: "center"
    },
    buttonSuccess: {
        backgroundColor: blue[500],
        "&:hover": {
            backgroundColor: blue[700]
        }
    },
    iconButtonActive: {
        fill: blue[500],
        "&:hover": {
            fill: blue[700]
        }
    },
    iconButtonInactive: {
        fill: grey[500],
        "&:hover": {
            fill: grey[700]
        }
    },
    fabProgress: {
        color: blue[500],
        position: "absolute",
        top: -4,
        left: -4,
        zIndex: 1
    },
    iconSuccess: {
        fill: "white"
    },
    wrapperIconButton: {
        position: "relative"
    },
    wrapper: {
        margin: theme.spacing.unit,
        position: "relative"
    }
});

class ReactionButton extends Component {
    state = {
        loading: false
    };

    static propTypes = {
        classes: PropTypes.object.isRequired,
        onReactionButtonClick: PropTypes.func.isRequired,
        numReactions: PropTypes.number,
        active: PropTypes.bool,
        useIconButton: PropTypes.bool
    };

    static defaultProps = {
        numReactions: 0,
        active: false,
        useIconButton: false
    };

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    handleButtonClick = () => {
        if (!this.state.loading) {
            this.props.onReactionButtonClick();
            this.setState(
                {
                    loading: true
                },
                () => {
                    this.timer = setTimeout(() => {
                        this.setState({
                            loading: false
                        });
                    }, 1000);
                }
            );
        }
    };

    render() {
        const { numReactions, classes, active, useIconButton } = this.props;
        const { loading } = this.state;

        const buttonClassname = classNames({
            [classes.buttonSuccess]: active && !loading
        });

        const iconClassName = classNames({
            [classes.iconSuccess]: active
        });

        const iconButtonSuccessClassName = classNames({
            [classes.iconButtonActive]: active,
            [classes.iconButtonInactive]: !active
        });

        const wrapperClassName = classNames({
            [classes.wrapperIconButton]: useIconButton,
            [classes.wrapper]: !useIconButton
        });

        let button;
        if (useIconButton) {
            button = (
                <IconButton onClick={this.handleButtonClick}>
                    <ThumbUp className={iconButtonSuccessClassName} />
                </IconButton>
            );
        } else {
            button = (
                <Button
                    fab
                    mini
                    style={{ boxShadow: "none" }}
                    color={active && !loading ? "primary" : "default"}
                    className={buttonClassname}
                    onClick={this.handleButtonClick}>
                    <ThumbUp className={iconClassName} />
                </Button>
            );
        }

        return (
            <div className={classes.root}>
                <div className={wrapperClassName}>
                    {button}
                    {loading &&
                        !useIconButton &&
                        <CircularProgress
                            size={48}
                            className={classes.fabProgress}
                        />}
                </div>
                <div className={wrapperClassName}>
                    <Typography type="body1">
                        {numReactions}
                    </Typography>
                </div>
            </div>
        );
    }
}

export default withStyles(styleSheet)(ReactionButton);



// WEBPACK FOOTER //
// ./src/components/ReactionButton.jsx